<div [id]="idModal" class="modal fade modal-filter" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">
                        Pesquisar Representante
                    </h4>        
                    
                    <!-- <span class="float-right">
                        <div class="btn-group">
                            <button type="button" class="btn btn-light" (click)="search()">
                                <i class="fas fa-search" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn btn-light" (click)="representanteFilter.clear()">
                                <i class="fas fa-eraser" aria-hidden="true"></i>
                            </button>
                            <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                                (click)="representanteFilter.toggleCollapse()">
                                <i class="fas fa-filter" aria-hidden="true"></i>
                                <i [class]="representanteFilter.collapseIcon" aria-hidden="true"></i>
                            </button>
                        </div>                
                    </span>  -->
                </div>
                <div class="modal-body" #modalBody>
                    <div class="row">
                        <div class="col-12">
                            <sgt-representante-filter
                                #representanteFilter
                                [filter]="filter"
                                [situacao]="situacao"
                                (filterChange)="onFilterChange()"
                                (filterCleaned)="onFilterCleaned()">
                            </sgt-representante-filter>
                        </div>
                    </div> 
    
                    <div class="row">
                        <div class="col-12">
                            <table class="table table-striped table-hover datatables" [id]="idDataTable">
                                <thead>
                                    <tr>
                                        <th class="col-codigo-integracao-erp text-right">Código ERP</th>
                                        <th class="col-nome">Nome</th>
                                        <th class="col-cnpj-cpf">CNPJ / CPF</th>
                                        <th class="col-situacao text-center" *ngIf="!situacao">Situação</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let entity of entities" (click)="onSelectEntity(entity)">
                                        <td class="col-codigo-integracao-erp text-right">{{entity.codigoIntegracaoErp}}</td>
                                        <td class="col-nome">{{entity.nome}}</td>
                                        <td class="col-cnpj-cpf">{{entity.cnpjCpf}}</td>
                                        <td class="col-situacao text-center"  *ngIf="!situacao">
                                            <span class="badge badge-success" *ngIf="entity.situacao === 1">Ativo</span>
                                            <span class="badge badge-danger" *ngIf="entity.situacao === 2">Inativo</span>
                                            <span class="badge badge-warning" *ngIf="entity.situacao === 3">Potencial</span>
                                        </td>                                        
                                    </tr>
                                </tbody>
                            </table>                    
                        </div>
                    </div>                
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-light" (click)="close()">
                        Cancelar
                    </button>
                </div>            
            </div>
        </div>
    </div>